jQuery(document).ready(function($) {
    /**
     * Takes the additional email address field from the Checkout page and
     * moves it to a more sensible location in the form. The plugin does not
     * allow for it to be moved in any other way.
     */
    const moveAdditionalEmailField = function() {
        const field2 = $('.woocommerce #_wmep_email_2');
        const field3 = $('.woocommerce #_wmep_email_3');
        const field4 = $('.woocommerce #_wmep_email_4');
        const field5 = $('.woocommerce #_wmep_email_5');

        const accountEmailField = $('.woocommerce #billing_email');

        // Account email field must exist
        if (accountEmailField.length !== 1) {
            return;
        }

        if (field2.length === 1) {
            const fieldRow2 = field2.closest('.form-row');
        }
        if (field3.length === 1) {
            const fieldRow3 = field3.closest('.form-row');
        }
        if (field4.length === 1) {
            const fieldRow4 = field4.closest('.form-row');
        }
        if (field5.length === 1) {
            const fieldRow5 = field5.closest('.form-row');
        }

        const additionalEmailFieldTarget = accountEmailField.closest('.form-row');

        // Rows must exist
        if (additionalEmailFieldTarget.length !== 1) {
            return;
        }

         // Remove for retail
         if (dalby.isTrade === 'no') {
             if (typeof fieldRow2 !== 'undefined') {
                 fieldRow2.remove();
             }
             if (typeof fieldRow3 !== 'undefined') {
                 fieldRow3.remove();
             }
             if (typeof fieldRow4 !== 'undefined') {
                 fieldRow4.remove();
             }
             if (typeof fieldRow5 !== 'undefined') {
                 fieldRow5.remove();
             }
         }

        // Move to a suitable location
        if (field5.length === 1) {
            additionalEmailFieldTarget.after(field5.closest('.form-row'));
        }
        if (field4.length === 1) {
            additionalEmailFieldTarget.after(field4.closest('.form-row'));
        }
        if (field3.length === 1) {
            additionalEmailFieldTarget.after(field3.closest('.form-row'));
        }
        if (field2.length === 1) {
            additionalEmailFieldTarget.after(field2.closest('.form-row'));
        }

        field5.on('input', function() {
            $('body').trigger('hide_show_emails');
        });

        field4.on('input', function() {
            $('body').trigger('hide_show_emails');
        });

        field3.on('input', function() {
            $('body').trigger('hide_show_emails');
        });

        field2.on('input', function() {
            $('body').trigger('hide_show_emails');
        });

        $('body').on('hide_show_emails', function() {
            let val2 = field2.val().trim();
            let val3 = field3.val().trim();
            let val4 = field4.val().trim();
            let val5 = field5.val().trim();

            if (val5 === '' && val4 === '') {
                field5.closest('.form-row').hide();
            } else {
                field5.closest('.form-row').show();
            }

            if (val4 === '' && val3 === '') {
                field4.closest('.form-row').hide();
            } else {
                field4.closest('.form-row').show();
            }

            if (val3 === '' && val2 === '') {
                field3.closest('.form-row').hide();
            } else {
                field3.closest('.form-row').show();
            }
        });
    }

    // Run
    moveAdditionalEmailField();

    $('body').trigger('hide_show_emails');
});





